// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__19VV8","light":"Tooltip_light__2hfik","dark":"Tooltip_dark__1W3th"};